<template>
  <div class="AuthorForm">
    <div class="content">
      <div class="title">
        <a
          class="back"
          href="/"
        >{{ $t('BUTTON.BACK') }}</a>
        <h2>{{ $t('AUTHORFORM.TITLE') }}</h2>
      </div>
      <form
        v-if="!loading"
        @input="validation($event)"
      >
        <div class="form-block">
          <BaseInput
            v-for="(field, i) in fields"
            :key="i"
            v-model="field.value"
            v-bind="field"
          >
            <template #error>
              <ValidationError
                :errors="errors"
                :name="field.name"
              />
            </template>
          </BaseInput>
          <BaseSelectForm
            v-model="genre"
            :value="genre"
            :label="$t('AUTHORFORM.GENRE')"
            tag="genero_id"
            :options="getGen"
          />
          <BaseSelectForm
            v-model="province"
            :value="province"
            :label="$t('AUTHORFORM.TERRITORY')"
            tag="territorio_id"
            :options="terName"
          />
          <div class="fileInput">
            <span>{{ $t('AUTHORFORM.PICTURE') }}</span>
            <input
              type="file"
              name="usr_image_id"
              @change="loadImage"
            >
          </div>

          <BaseSelectForm
            v-model="anotherActivity"
            :value="anotherActivity"
            :label="$t('AUTHORFORM.ACTIVITY')"
            tag="otraactividad_id"
            :options="getAct"
          />
        </div>
        <div class="declaration-box">
          <p
            class="declaration"
            v-html="$t('AUTHORFORM.DECLARATION', {path: documentPath})"
          />
          <div class="fileInput">
            <span>
              {{ $t('AUTHORFORM.DECLARATION4') }}
            </span>

            <input
              type="file"
              name="dec_id"
              @change="loadImage"
            >
          </div>
        </div>

        <div class="message">
          <p
            v-if="created"
            class="created"
          >
            Usuario registrado correctamente
          </p>
        </div>

        <div class="button-sub">
          <BaseButton @click="submitData">
            {{ $t('BUTTON.SAVE') }}
          </BaseButton>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import { get } from 'vuex-pathify';
import ValidationError from '@/components/ValidationError.vue';
import ValidationMixin from '@/mixins/ValidationMixin.js';
// import authModule from '@/store/authModule.js';

export default {
  components: {
    ValidationError,
  },
  mixins: [ValidationMixin],

  data() {
    return {
      // formData: {},
      fields: undefined,
      image: undefined,
      province: '',
      locality: '',
      genre: '',
      anotherActivity: '',
      declaration: undefined,
      created: false,

    };
  },
  computed: {
    ...get('authorsModule', [
      'getGeneros',
      'getTerritory',
      'getLocality',
      'getOtraactividad',
      'getIdiomas',
    ]),

    documentPath() {
      if (!window || !window.location || !window.location.origin) {
        return '#';
      }

      return `${window.location.origin}/documents/DECLARACION_RESPONSABLE_CENSO_DE_ARTISTAS.docx`;
    },

    currentLocale: get('localeModule/locale'),

    ...get('authModule', ['register']),

    loading: get('authorsModule/loading'),

    getGenero() {
      return this.getGeneros();
    },

    getGen() {
      if (!this.getGenero) return undefined;
      return this.getGenero.reduce((acc, genre) => ({ ...acc, [genre.id]: genre.txt }), {});
    },

    getIdioma() {
      return this.getIdiomas();
    },

    getIdio() {
      if (!this.getIdioma) return undefined;
      return this.getIdioma.reduce((acc, lenguage) => ({ ...acc, [lenguage.id]: lenguage.txt }), {});
    },

    getTer() {
      return this.getTerritory();
    },

    terName() {
      if (!this.getTer) return undefined;
      return this.getTer.reduce((acc, province) => ({ ...acc, [province.id]: province.txt }), {});
    },

    getLoc() {
      return this.getLocality();
    },

    // locName() {
    //   if (!this.getLoc) return undefined;
    //   return this.getLoc.reduce((acc, locality) => ({ ...acc, [locality.id]: locality.txt }), {});
    // },

    getActivity() {
      return this.getOtraactividad();
    },

    getAct() {
      if (!this.getActivity) return undefined;
      return this.getActivity.reduce((acc, anotherActivity) => ({ ...acc, [anotherActivity.id]: anotherActivity.txt }), {});
    },
  },

  watch: {
    currentLocale(newValue, oldValue) {
      console.log(newValue);
      if (newValue !== oldValue) {
        this.loadData();
      }
    },
  },


  async created() {
    this.loadData();
  },

  methods: {
    loadImage(e) {
      // const input = event.target;

      // if (input.files && input.files[0]) {
      //   this.image = input.files[0];
      // }
      try {
        const files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        const file = files[0];
        const reader = new FileReader();

        reader.onload = (ev) => {
          this.image = ev.target.result;
          console.log(this.image);
        };
        reader.readAsDataURL(file);
      } catch (error) {
        console.log(error);
      }
    },

    loadDoc(event) {
      const input = event.target;

      if (input.files && input.files[0]) {
        console.log(input.files);
        this.declaration = input.files[0];
      }
    },

    async loadData() {
      this.fields = this.getFields();
      // calls to store action
      await this.$store.dispatch('authorsModule/fetchTerritorios');
      await this.$store.dispatch('authorsModule/fetchGeneros');
      await this.$store.dispatch('authorsModule/fetchIdiomas');
      await this.$store.dispatch('authorsModule/fetchOtraActividad');
    },

    getFields() {
      return [
        {
          type: 'text', label: this.$t('AUTHORFORM.NAME'), name: 'nombre', value: undefined, placeholder: this.$t('AUTHORFORM.NAMEPLACEHOLDER'), required: 'required',
        },
        {
          type: 'text', label: this.$t('AUTHORFORM.SURNAME'), name: 'apellidos', value: undefined, placeholder: this.$t('AUTHORFORM.SURNAMEPLACEHOLDER'), required: 'required',
        },
        {
          type: 'text', label: this.$t('AUTHORFORM.EMAIL'), name: 'email', value: undefined, placeholder: this.$t('AUTHORFORM.EMAILPLACEHOLDER'), required: 'required',
        },
        {
          type: 'text', label: this.$t('AUTHORFORM.EMAILREPEAT'), name: 'repeatemail', value: undefined, placeholder: this.$t('AUTHORFORM.EMAILREPEATPLACEHOLDER'), required: 'required',
        },
        {
          type: 'password', label: this.$t('AUTHORFORM.PASSWORD'), name: 'password', value: undefined, placeholder: this.$t('AUTHORFORM.PASSWORDPLACEHOLDER'), required: 'required',
        },
        {
          type: 'password', label: this.$t('AUTHORFORM.PASSWORDREPEAT'), name: 'repeatpass', value: undefined, placeholder: this.$t('AUTHORFORM.PASSWORDREPEATPLACEHOLDER'), required: 'required',
        },
        {
          type: 'text', label: this.$t('AUTHORFORM.ID'), name: 'dni', value: undefined, placeholder: this.$t('AUTHORFORM.IDPLACEHOLDER'), required: 'required',
        },
      ];
    },

    async getTerId() {
      if (this.province === '') {
        await this.$store.dispatch('authorsModule/resetLocality');
        this.locality = '';
      } else {
        await this.$store.dispatch('authorsModule/fetchMunicipios', this.province);
      }
    },

    getField(name) {
      return this.fields.find(field => field.name === name)?.value;
    },

    async submitData() {
      const password = this.getField('password');
      const repeatpass = this.getField('repeatpass');
      const email = this.getField('email');
      const repeatemail = this.getField('repeatemail');

      try {
        if (this.areErrors()) {
          throw new Error(this.$t('FORM.MESSAGE.ERROR.CHECKFIELDS'));
        } else {
          const currentForm = document.forms[0];
          console.log('currentForm', currentForm);
          if (email !== repeatemail) {
            const repeatemailField = currentForm.querySelector('[name=repeatemail]');
            this.forceErrorElement(repeatemailField, 'Los emails deben coincidir'); // mensaje debajo del campo
            throw new Error('Los emails deben coincidir'); // mensaje en toast
          }

          if (password !== repeatpass) {
            const repeatpassField = currentForm.querySelector('[name=repeatpass]');
            this.forceErrorElement(repeatpassField, 'Las contraseñas deben coincidir'); // mensaje debajo del campo
            throw new Error('Las contraseñas deben coincidir'); // mensaje en toast
          }

          this.checkAllFields(currentForm); // Chequear campos
          // console.log('cF', currentForm);
          const formData = new FormData(currentForm);
          await this.$store.dispatch('authorsModule/postAuthor', formData);
          this.created = true;
        }
      } catch (error) {
        this.$toast.error(error.message);
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.AuthorForm {
  background-size: cover;
  background-image: url('~@/assets/images/background/back-1.jpg');
  .content {
    max-width: 1200px;
    margin: 0 auto;
    padding-bottom: 2rem;
    background-color: rgb(221, 224, 224);
    border-collapse: collapse;
    .back {
      color: white;
      background-color: var(--color-primary);
      display: inline-block;
      padding: 0.5rem;
      width: 120px;
      text-decoration: none;
      text-transform: uppercase;
      font-size: 1.1rem;
      &::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        border-left: solid 2px white;
        border-bottom: solid 2px white;
        transform: rotate(45deg) translateY(-3px);
        margin-right: 5px;
      }
    }

    .title {
      background-color: var(--color-neutral-darker);
      text-align: center;
      display: flex;
      a {
        display: flex;
        align-items: center;
        transition: background-color 0.5s ease;
        &:hover {
          background-color: var(--color-primary-light);
        }
      }
      h2 {
        color: white;
        font-size: 2rem;
        font-weight: bold;
        text-transform: uppercase;
        margin: 0;
        padding: 1rem 0;
        flex: 1 0 auto;
        @media #{$breakpoint-sm-max} {
          font-size: 1.3rem;
        }
      }
    }
    form {
      .form-block {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
        gap: 0.3rem;
        padding: 1.5rem;
        @media #{$breakpoint-sm-max} {
          padding: 1rem 1rem;
        }
        > * {
          flex: 1 0 auto;
        }
        .fileInput{
          margin:.5rem 0 ;
          display: flex;
          flex-direction: column;
          ::v-deep {
            span {
              align-self: left;
              padding-bottom: 0.5rem;
              width: 300px;
              margin: 0 auto;
            }
            input {
              font-size: var(--font-size-m);
              padding: .3rem 1rem;
              border: solid 2px var(--color-primary);
              border-radius: 10px;
              width: 300px;
              margin: 0 auto;
              background-color: rgb(243, 243, 243);
              &.invalid {
                border: solid 1px red;
              }
            }
          }
        }
        .BaseInput {
          display: flex;
          flex-direction: column;
          ::v-deep {
            label {
              align-self: left;
              padding-bottom: 0.5rem;
              width: 300px;
              margin: 0 auto;
            }
            input {
              border: solid 2px var(--color-primary);
              border-radius: 10px;
              width: 300px;
              margin: 0 auto;
            }
          }
        }
      }

      .BaseSelectForm {
        display: flex;
        flex-direction: column;
        ::v-deep {
          label {
            align-self: left;
            padding-bottom: 0.5rem;
            width: 300px;
            margin: 0 auto;
            margin-top: 7px;
          }
          select {
            border: solid 2px var(--color-primary);
            border-radius: 10px;
            padding: 0.3rem 0.5rem;
            background-color: #fff;
            width: 300px;
            margin: 0 auto;
          }
        }
      }
      .declaration-box {
        width: 80%;
        margin: 0 auto;
        padding: 1rem;
        background-color: #d1d9e1;
        border-radius: 10px;
        text-align: left;
        .declaration {
          margin-bottom: 1rem;
          //grid-column: 2 span;
        }
        .fileInput {
          display: flex;
          flex-direction: column;
          ::v-deep {
            span {
              align-self: left;
              padding-bottom: 0.5rem;
              width: 300px;
            }
            input {
              font-size: var(--font-size-m);
              padding: .3rem 1rem;
              border: solid 2px var(--color-primary);
              border-radius: 10px;
              width: 300px;
              background-color: rgb(243, 243, 243);
              &.invalid {
                border: solid 1px red;
              }
            }
          }
        }
      }
      .BaseInput {
        display: flex;
        flex-direction: column;
        ::v-deep {
          label {
            padding-bottom: 0.5rem;
          }
          input {
            border: solid 2px var(--color-primary);
            border-radius: 10px;
            width: 300px;
            margin: auto;
          }
        }
      }
    }
    .created {
      display: flex;
      flex-wrap: wrap;
      padding-top: 2rem;
      padding-left: 30rem;
      @media #{$breakpoint-sm-max} {
        padding: 1rem 9rem;
      }
      > * {
        flex: 1 0 auto;
      }
    }
    .button-sub {
      text-align: center;
      padding-top: 2rem;
    }
  }
}
</style>
